<template>
  <div class="flex items-center">
    <span class="px-3 py-1 rounded-full bg-blue-100 uppercase text-xs font-bold text-gray-600">{{data.type}}</span>
  </div>
</template>

<script>

export default {
  name: "AutoresponderType",
  props: {
    meta: {
      type: Object,
      default: () => { }
    },
    name: {
      type: String,
      default: ''
    },
    data: {
      type: Object,
      default: () => { }
    },
    click: {
      type: Function,
      default: () => { }
    }
  }
}
</script>

<style scoped>
.contact-table-actions {
  max-width: 40px;
}
</style>
